var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tab_offer_unselected.d7db7233.png",
    width: 72,
    height: 72
});